<template>
  <base-link
    :class="brandClasses.wrapper"
    :target="content.target?.targetAttribute"
    :to="content.target?.url"
    @click="handleClick"
  >
    <base-picture
      alt=""
      :class="brandClasses.picture"
      fit="cover"
      v-bind="media"
    />
    <span v-style="brandStyles.title" :class="brandClasses.title">
      {{ content.title }}
    </span>
  </base-link>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { VisualSelector } from '#types/components/cms/mega-menu'
import { MegaMenuL2ContextKey } from '#content/contexts/megamenu'

const { content, isWide } = defineProps<{
  content: VisualSelector
  isWide: Responsive<boolean>
}>()

const { $gtm } = useNuxtApp()
const appConfig = useAppConfig()
const { breakpoints } = appConfig.ds
const { brandClasses, brandStyles } = appConfig.components.cms.megaMenuVisualSelector
const l2 = inject(MegaMenuL2ContextKey, undefined)

const media = Object.entries(breakpoints).reduce(
  (acc, [k]) => {
    const source = getValueForBreakpoint(k as keyof Responsive, isWide)
      ? content.mediaObject8x5
      : content.mediaObject4x5
    const value = getValueForBreakpoint(k as keyof Responsive, source)
    if (!value) return acc
    return {
      height: { ...acc.height, [k]: value.height },
      src: { ...acc.src, [k]: value.url },
      width: { ...acc.width, [k]: value.width },
    }
  },
  {} as { height: Responsive<number>, src: Responsive, width: Responsive<number> },
)

const handleClick = () => {
  if (!content.target?.url || !l2?.title) return
  $gtm.push('topNav.onClickTopNavContent', `L1 - ${l2.title} | L2 - ${content.title}`)
}
</script>
